import { withLocalState } from 'pyradux';

import TransactionsContainer from './Transactions.container';
import reducer from './Transactions.reducer';
import TransactionsSagas from './Transactions.sagas';

const withLocalStateOptions = {
  reducer,
  stateKey: 'transactions',
  sagas: [TransactionsSagas],
};

export default withLocalState(withLocalStateOptions, TransactionsContainer);



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/Transactions/index.js